import React from 'react';
import Select from 'react-select-next';
import { FieldWrapper } from './auxiliary/FieldWrapper';
import { fieldWrapperProps } from '../../services/fieldUtils';
import { selectorCustomStyles } from './auxiliary/selectorCustomStyles';
import { defaultOptionRenderer } from './selectorOptionRenderers/defaultOptionRenderer';

export const MultiSelectorField = props => {
  const {
    field: { name, value },
    form: { setFieldValue, setFieldTouched },
    options,
    disabled,
    onChange,
    onBlur,
    placeholder,
    optionRenderer = defaultOptionRenderer(),
    headerRenderer = optionRenderer,
    resourceName,
    id,
  } = props;

  const selectorValues = options.filter(o => value?.includes(o.value));
  const inputId = id || `${resourceName}-${name}`;

  const defaultOnChange = async selections => {
    await setFieldValue(
      name,
      selections.map(s => s.value),
    );
    await setFieldTouched(name, true);
  };
  const defaultOnBlur = async () => {
    await setFieldTouched(name, true);
  };

  return (
    <FieldWrapper {...fieldWrapperProps({ inputId, ...props })}>
      <div style={{ width: '100%' }}>
        <Select
          inputId={inputId}
          classNamePrefix={inputId}
          value={selectorValues}
          options={options}
          styles={selectorCustomStyles}
          isDisabled={disabled}
          placeholder={placeholder}
          menuPlacement="auto"
          onChange={selections => {
            // eslint-disable-next-line no-unused-expressions
            onChange ? onChange(selections, defaultOnChange) : defaultOnChange(selections);
          }}
          onBlur={e => {
            // eslint-disable-next-line no-unused-expressions
            onBlur ? onBlur(e, defaultOnBlur) : defaultOnBlur();
          }}
          formatOptionLabel={(option, { context }) =>
            context === 'value' ? headerRenderer(option.data) : optionRenderer(option.data)
          }
          isMulti
        />
      </div>
    </FieldWrapper>
  );
};
